import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import { environment } from '../../../environments/environment'

export interface NbStation {
  id: number
  title: string
  description: string
  bpm: string
  show_vipgenre: boolean
  show_wideimage: boolean
  aspect_ratio: string
  partner?: boolean
  active?: boolean
  direct_play?: boolean
  image?: string
  thumbnail?: string
  wide_image?: string
  player_image?: string
  basic_img?: string
  wide_img?: string
  spotlight_img?: string
}
export interface NbStationsResponse {
  success: boolean
  stations: NbStation[]
}

export interface NbStationResponse {
  success: boolean
  station: NbStation
}

export interface NbStationSuccessResponse {
  success: boolean
}

@Injectable()
export class StationService {
  private API_ENDPOINT = `${environment.HOST}/adminapi/station/`

  constructor(private http: HttpClient) {}

  public getAllStations(): Observable<NbStationsResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}get`)
      .map(res => res as NbStationsResponse)
  }

  public getStationByID(id: number): Observable<NbStationResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getstation/id/${id}`)
      .map(res => res as NbStationResponse)
  }

  public saveStation(station: NbStation): Observable<NbStationSuccessResponse> {
    return this.http
      .post(`${this.API_ENDPOINT}save`, station)
      .map(res => res as NbStationSuccessResponse)
  }

  public deleteStation(id: number): Observable<NbStationSuccessResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}delete/id/${id}`)
      .map(res => res as NbStationSuccessResponse)
  }
}



// WEBPACK FOOTER //
// /srv/dev/FitRadioAdmin2/src/app/@core/data/station.service.ts